// Dice i18n bootstrap: resolves locale, loads catalog, applies document lang/dir.
import {
  getEnglishCatalog,
  I18n,
  loadLocaleCatalog,
  mergeCatalogs,
  resolveLocale,
  type ResolveLocaleInput,
  type SupportedLocale,
} from '@aerofruits/i18n';

let active: I18n | undefined;

export function applyDocumentLocale(i18n: I18n): void {
  if (typeof document === 'undefined') return;
  document.documentElement.lang = i18n.getLocale();
  document.documentElement.dir = i18n.getDir();
}

/** Initializes the global I18n instance (idempotent on same locale). */
export async function initI18n(input: ResolveLocaleInput): Promise<I18n> {
  const locale = resolveLocale(input);
  const fallback = getEnglishCatalog();
  const loaded = locale === 'en' ? fallback : mergeCatalogs(fallback, await loadLocaleCatalog(locale));
  if (active && active.getLocale() === locale) {
    applyDocumentLocale(active);
    return active;
  }
  active = new I18n(locale, loaded, fallback);
  applyDocumentLocale(active);
  return active;
}

export function getI18n(): I18n {
  if (!active) {
    const fallback = getEnglishCatalog();
    active = new I18n('en', fallback, fallback);
  }
  return active;
}

export async function switchLocale(locale: SupportedLocale): Promise<I18n> {
  const i18n = getI18n();
  await i18n.setLocale(locale);
  applyDocumentLocale(i18n);
  return i18n;
}
